import { render, staticRenderFns } from "./AtomParagraph.vue?vue&type=template&id=db916e36&"
import script from "./AtomParagraph.vue?vue&type=script&lang=ts&"
export * from "./AtomParagraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports